import axios from "../api";

export const listCountriesAction = (
  page,
  limit,
  search = "",
  code = "",
  name = ""
) => {
  let apiUrl = `/api/kyc/countries?page=${page}&limit=${limit}`;

  if (search) {
    apiUrl += `&search=${search}`;
  }

  if (code) {
    apiUrl += `&code=${code}`;
  }

  if (name) {
    apiUrl += `&name=${name}`;
  }

  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => resolve(response.data))
      .catch((error) => {
        console.error("ERROR:", error);
        reject(error);
      });
  });
};